import request from '@/utils/request' 

// 示例：封装一个提交数据的 POST 请求
export function mlogins(data) {
    return request({
      url: '/api/m-backend/mlogin',
      method: 'post',
      data: data
    })
  }


  // 获取路由
export const getRouters = (query) => {
    return request({
      url: '/getRouters',
      method: 'get',
      params: query
    })
  }

  // 根据参数键名查询参数值
export function getConfigKey(configKey) {
  return request({
    url: '/system/config/configKey/' + configKey,
    method: 'get'
  })
}
// 查询用户个人信息
export function getUserProfile() {
  return request({
    url: '/system/user/profile',
    method: 'get'
  })
}